import { Accordion, AccordionHeader, AccordionItem, AccordionPanel, makeStyles } from "@fluentui/react-components";
import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { ResetButton } from "./ResetButton";

const useStyles = makeStyles({
  accordionPanel: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "20px"
  },
  accordionRow: {
    display: "flex",
    minHeight: "var(--lineHeightBase600, 32px)",
    gap: "10px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch"
  },
  accordionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  }
});

export function GraphicsSettings({ children, onResetToDefaultGraphics }) {
  const styles = useStyles();

  return (
    <div>
      <Accordion collapsible multiple defaultOpenItems={["1"]}>
        <AccordionItem value="1">
          <AccordionHeader>
            <div className={styles.accordionHeader}>
              <FormattedMessage id="preferences-screen.category.graphics" defaultMessage="Graphics" />
              <ResetButton onClick={onResetToDefaultGraphics} />
            </div>
          </AccordionHeader>
          <AccordionItem value="1">
            <AccordionPanel className={styles.accordionPanel}>{children}</AccordionPanel>
          </AccordionItem>
        </AccordionItem>
      </Accordion>
    </div>
  );
}

// Add proptypes
GraphicsSettings.propTypes = {
  children: PropTypes.node,
  onResetToDefaultGraphics: PropTypes.func
};
